<template lang="pug">
  .container
    v-row
      v-col(cols=12 md=4 lg=4)
        h2.mb-3 Для индивидуальной записи
        agreements-cards(
          :cards="[agreements[$conf.CONTRACT_TYPES.ip]]"
          @update="(val) => updateAgreements(val, 1)"
          @delete="$emit('delete', $conf.CONTRACT_TYPES.ip)"
        )
      v-divider.ma-5(vertical)
      v-col(cols=12 md=4 lg=4)
        h2.mb-3 Для записи группы обучающихся
        agreements-cards(
          :cards="[agreements[$conf.CONTRACT_TYPES.ur], agreements[$conf.CONTRACT_TYPES.not_offer]]"
          @update="(val, idx) => updateAgreements(val, idx + 2)"
          @delete="$emit('delete', idx ? $conf.CONTRACT_TYPES.not_offer : $conf.CONTRACT_TYPES.ur)"
        )
</template>

<script>
import FileUpload from '@/components/InputFields/FileUpload.vue';
import FileInput from '@/components/InputFields/FileInput.vue';
import AgreementsCards from '@/modules/PaymentSystem/components/AgreementsCards.vue';

export default {
  components: {
    AgreementsCards,
    FileInput,
    FileUpload,
  },
  props: {
    agreements: { type: Object, required: true },
  },

  methods: {
    updateAgreements(val, idx) {
      this.$set(this.agreements, idx, val);
    },
  },
};
</script>
